import React, { Component } from 'react';
import axios from '../api';
import Swal from 'sweetalert2';
import {Link} from "react-router-dom";

const req = {
  color: 'red'
}
class ForgotPassword extends Component {
  constructor(props) {
    super();
    this.state = {
      email: "",
      error: null
    }
    this.submitForgotPassword = this.submitForgotPassword.bind(this);
  }

  submitForgotPassword() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!this.state.email || this.state.email === null || !re.test(String(this.state.email).toLowerCase())) {
      this.setState({
        error: 'Enter valid email address'
      });
      return;
    }
    axios.post("/benefit/forgot-password", {email: this.state.email}).then(res => {
      Swal.fire(
        'Success',
        `Reset Link sent to ${this.state.email}`,
        'success'
      );
      this.setState({
        email: ''
      });
    }, err => {
      this.setState({
        error: err.response.data || 'Unable to process, Try Again Later'
      });
    });
  }

  render() {
    let error;
    if(this.state.error) {
      error = <p style={{fontSize:'15px',...req}} className="text-center">{this.state.error}</p>
    }
    return (
      <div className="row justify-content-center">
        <div className="col-4 signInContainer">
          <h4 className="text-center" style={{marginBottom:'20px'}}>Forgot Password</h4>
          {error}
          <div className="form-group">
            <label>Email address <span style={req}>*</span></label>
            <input type="email" className="form-control" value={this.state.email} onChange={(event) => {
              this.setState({
                email: event.target.value
              })
            }} onKeyDown={(event) => {
              if (event.keyCode === 13) {
                event.preventDefault();
                this.submitForgotPassword();
              }
              }} placeholder="Enter email"/>
          </div>
          <div className="signInContainer-buttons">
            <Link className="careButton" to="/login" value="Go" >Back to Login</Link>
            <div className="careButton" disabled="" id="signIn" value="Go" onClick={(event) => {
                event.preventDefault();
                this.submitForgotPassword();
              }}>Reset Password</div>
          </div>
        </div>
      </div>
    );
  }
};

export default ForgotPassword;
